const testimonialData = [
    {
      imglink: "img/tutul.jpg",
      name: "Tutul Samanta",
      profession: "Indian Maritime University, Kolkata campus ",
      testimonial:
        "First time in Samudramanthan! Amazing experience Won Best Campus Ambassador Award Will Come again!.",
    },
    {
      imglink: "img/surya.jpg",
      name: "Surya Vamsi Krishna ",
      profession: "Marine Engineering at HIMT college",
      testimonial:
        "It was really a great event with a really wonderful exposure to the hub of smart thinkers. All credits goes to the organizers who have been as the backbone for the event to be successful. Good luck guys.",
    },
    {
      imglink: "img/shubh.jpg",
      name: "Shubh M Shivolkar",
      profession: "Indian Maritime University, Visakhapatnam Campus ",
      testimonial:
        "it was a great experience hoping next time ull come up with even more best of luck.",
    },
    {
      imglink: "img/akash.jpg",
      name: "Akash Meena ",
      profession: "IIT Kharagpur ",
      testimonial:
        "The national level inter college annual technical meet of the department of Ocean Engineering and Naval Architecture, IIT Kharagpur organized by Naval Architecture and Ocean Engineering Society (NAROES), IIT Kharagpur in every spring semester. Samudramanthan’s journey toward excellence started in 2009 with its first ever edition.",
    },
    {
      imglink: "img/amdad.jpg",
      name: "Amdad Muhammed ",
      profession: "IIT Kharagpur ",
      testimonial:
        "We came here not sure what to expect. Today we are leaving hoping to come back again. Wonderfully organized & the efforts towards improvement put by their team is heartening.",
    },
  ];
  
  export default testimonialData;